(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ReactDOM"), require("React"));
	else if(typeof define === 'function' && define.amd)
		define(["ReactDOM", "React"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("ReactDOM"), require("React")) : factory(root["ReactDOM"], root["React"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__81845__, __WEBPACK_EXTERNAL_MODULE__4883__) => {
return 